import React, { useRef } from 'react';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JavaScript

import './Banner.css';

export default class Banner extends React.Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef(); // Reference for the first video (Ranger/Everest)
        this.terVideoRef = React.createRef(); // Reference for ter.mp4 (Territory)
        this.taurusVideoRef = React.createRef(); // Reference for Taurus video
        this.carouselRef = React.createRef(); // Reference for the carousel
        this.state = {
            videoSource: this.getVideoSource(),
            territoryVideoSource: this.getTerritoryVideoSource(),
            taurusVideoSource: this.getTaurusVideoSource(),
            isMobile: window.innerWidth < 768
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        // Add event listener to trigger the next slide when a video ends
        this.videoRef.current.addEventListener('ended', this.handleVideoEnd);
        if (this.terVideoRef.current) {
            this.terVideoRef.current.addEventListener('ended', this.handleVideoEnd);
        }
        if (this.taurusVideoRef.current) {
            this.taurusVideoRef.current.addEventListener('ended', this.handleVideoEnd);
        }

        // Add listener for slide changes
        this.carouselRef.current.addEventListener('slid.bs.carousel', this.handleSlideChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        // Cleanup event listeners (guard refs in case they are null)
        if (this.videoRef?.current) {
            this.videoRef.current.removeEventListener('ended', this.handleVideoEnd);
        }
        if (this.terVideoRef?.current) {
            this.terVideoRef.current.removeEventListener('ended', this.handleVideoEnd);
        }
        if (this.taurusVideoRef?.current) {
            this.taurusVideoRef.current.removeEventListener('ended', this.handleVideoEnd);
        }
        if (this.carouselRef?.current) {
            this.carouselRef.current.removeEventListener('slid.bs.carousel', this.handleSlideChange);
        }
    }

    
    handleResize = () => {
        this.setState({
            videoSource: this.getVideoSource(),
            territoryVideoSource: this.getTerritoryVideoSource(),
            taurusVideoSource: this.getTaurusVideoSource(),
            isMobile: window.innerWidth < 768
        });
    }


    handleVideoEnd = () => {
        // Move to the next slide after the video ends
        const carousel = this.carouselRef.current;
        if (carousel) {
            const carouselInstance = new bootstrap.Carousel(carousel);
            carouselInstance.next();
        }
    };

    handleSlideChange = () => {
        const activeSlide = this.carouselRef.current.querySelector('.carousel-item.active');
        const isFirstVideoSlide = activeSlide.contains(this.videoRef.current);
        const isTerVideoSlide = this.terVideoRef.current && activeSlide.contains(this.terVideoRef.current);
        const isTaurusVideoSlide = this.taurusVideoRef.current && activeSlide.contains(this.taurusVideoRef.current);

        if (isFirstVideoSlide) {
            this.videoRef.current.currentTime = 0;
            this.videoRef.current.play();
        } else if (isTerVideoSlide) {
            this.terVideoRef.current.currentTime = 0;
            this.terVideoRef.current.play();
        } else if (isTaurusVideoSlide) {
            this.taurusVideoRef.current.currentTime = 0;
            this.taurusVideoRef.current.play();
        }
    };
    getVideoSource = () => {
        const width = window.innerWidth;
        if (width < 768) {
            return "/videos/414x646.mp4";  // Mobile
        } else if (width < 1024) {
            return "/videos/768x464.mp4";  // Tablet
        }
        return "/videos/1257x759_2.mp4";   // Desktop
    }

    getTerritoryVideoSource = () => {
        const width = window.innerWidth;
        if (width < 768) {
            return "/videos/territory/646x415.mp4";  // Mobile
        } else if (width < 1024) {
            return "/videos/territory/768x464.mp4";  // Tablet
        }
        return "/videos/territory/1257x759.mp4";   // Desktop
    }

    getTaurusVideoSource = () => {
        const width = window.innerWidth;
        if (width < 768) {
            return "/videos/taurus/414x646.mp4";  // Mobile
        } else if (width < 1024) {
            return "/videos/taurus/768x464.mp4";  // Tablet
        }
        return "/videos/taurus/1257x759.mp4";   // Desktop
    }

    render() {
        return (

            <>
                <div className={'banner-new banner-'+process.env.REACT_APP_WHICH_APP}>

                    <div className="ford">
                        <div id="carouselExample" className="carousel slide" data-bs-touch="true" ref={this.carouselRef}>
                            <div className="carousel-indicators">
                                <button
                                    type="button"
                                    data-bs-target="#carouselExample"
                                    data-bs-slide-to="0"
                                    className="active"
                                    aria-current="true"
                                    aria-label="Slide 1"
                                ></button>
                                <button
                                    type="button"
                                    data-bs-target="#carouselExample"
                                    data-bs-slide-to="1"
                                    aria-label="Slide 2"
                                ></button>
                                <button
                                    type="button"
                                    data-bs-target="#carouselExample"
                                    data-bs-slide-to="2"
                                    aria-label="Slide 3"
                                ></button>
                            </div>
                            <div className="carousel-inner">
                                {/* 1. Old Ranger/Everest video - First */}
                                <div className="carousel-item active">
                                    <div className="d-flex align-items-center justify-content-center h-100">
                                        <video
                                            ref={this.videoRef}
                                            className="video-background"
                                            style={{
                                                objectFit: 'cover',
                                                width: '100%',
                                                height: '100%'
                                            }}
                                            muted
                                            playsInline
                                            autoPlay
                                        >
                                            <source src={this.state.videoSource} type="video/mp4" />
                                        Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                                {/* 2. Territory new video (ter.mp4) - Second */}
                                <div className="carousel-item">
                                    <div className="d-flex align-items-center justify-content-center h-100">
                                        <video
                                            ref={this.terVideoRef}
                                            className="video-background"
                                            style={{
                                                objectFit: 'cover',
                                                width: '100%',
                                                height: this.state.isMobile ? '100%' : 'auto'
                                            }}
                                            muted
                                            playsInline
                                        >
                                            <source src="/videos/ter.mp4" type="video/mp4" />
                                        Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                                {/* 3. Taurus video - Third */}
                                <div className="carousel-item">
                                    <div className="d-flex align-items-center justify-content-center h-100">
                                        <video
                                            ref={this.taurusVideoRef}
                                            className="video-background"
                                            style={{
                                                objectFit: 'cover',
                                                width: '100%',
                                                height: this.state.isMobile ? '100%' : 'auto'
                                            }}
                                            muted
                                            playsInline
                                        >
                                            <source src={this.state.taurusVideoSource} type="video/mp4" />
                                        Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container banner-content-wrapper d-none d-sm-block">
                            <div className="content">
                                <h1>
                                    <span language="en">{process.env.REACT_APP_WHICH_APP} Accessories</span>
                                    <span language="ar">ملحقات {process.env.REACT_APP_WHICH_APP}</span>
                                </h1>
                                <h3>
                                    <span language="ar">هنا تكتمل أناقة سيارتك</span>
                                    <span language="en">Accessorize in Style</span>
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div className="lincoln">
                        <div className="container">
                            <div className="content">
                                <h1>
                                    <span language="en">{process.env.REACT_APP_WHICH_APP} Accessories</span>
                                    <span language="ar">ملحقات {process.env.REACT_APP_WHICH_APP}</span>
                                </h1>
                                <h3>
                                    <span language="ar">هنا تكتمل أناقة سيارتك</span>
                                    <span language="en">Accessorize in Style</span>
                                </h3>
                            </div>
                        </div>
                    </div>

                </div>
            </>

        )
    }
}